import { Injectable } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountdownService {
  private subscription: Subscription;
  public countdownTime: number;
  public displayTime: string;
  private isRunning = false;

  constructor() {
    this.countdownTime = 0; // Initialize countdown time
    this.displayTime = '0:00'; // Initialize display time
  }

  startCountdown(seconds: number): void {
    if (this.isRunning) {
      return;
    }

    this.stopCountdown(); // clean up old timer just in case

    this.isRunning = true;
    this.countdownTime = seconds;
    this.updateDisplayTime();

    this.subscription = interval(1000).subscribe(() => {
      if (this.countdownTime > 0) {
        this.countdownTime--;
        this.updateDisplayTime();
      } else {
        this.stopCountdown();
      }
    });
  }

  stopCountdown(): void {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
    this.subscription = null;
    this.isRunning = false;
  }

  getRemainingTime(): string {
    return this.displayTime;
  }

  private updateDisplayTime(): void {
    const minutes = Math.floor(this.countdownTime / 60);
    const seconds = this.countdownTime % 60;
    this.displayTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }
}